export default "__VITE_ASSET__rcyTghkP__"